import React from 'react';

import {Card} from '../../../components/Card/Card';

import icon_call from './icon-call.svg'
import icon_vita from './vita-favicon.svg'

import cls from './Structure.module.scss'

export const Structure = () => (
    <div className={cls.block}>
        <h2>Что входит в&nbsp;услугу</h2>
        <div className={cls.cards}>
            <Card color={'pink'} bottom={
                <div className={cls.content}>
                    <h2>Онлайн консультация с&nbsp;нутрициологом</h2>
                    <div>Опытные врачи оценят состояние вашего здоровья и&nbsp;дадут рекомендации по&nbsp;корректировкам питания, образа жизни, а&nbsp;также дадут рекомендации по&nbsp;применению витаминно-минеральных добавок
                    </div>
                </div>
            }><img src={icon_call} alt={'Icon Call'}/></Card>
            <Card color={'black'} bottom={
                <div className={cls.content}>
                    <h2>Доступ в&nbsp;Приложение VITA для iOS и&nbsp;Android</h2>
                    <div>Cоставит профиль вашего здоровья, рассчитает ваш биологический возраст, даст рекомендации по&nbsp;чекам, поможет отслеживать онлайн динамику ваших лабораторных и&nbsp;инструментальных исследований
                    </div>
                </div>
            }><img src={icon_vita} alt={'Icon Vita'}/></Card>
        </div>
    </div>
)